import { useEffect, useState, useMemo } from "react";
import PromoVoucherModal, { Voucher } from "./PromoVoucherModal";
import { useNavigate } from "react-router-dom";
import { fetchVourcherList, checkVourcherListProducts } from "../../api/Vourcher";
import { Vourcher } from "../../api/VourcherType";
import { ProductFull } from "./CartAction";
import { message } from "antd";

interface CartSummarySidebarProps {
    totalQuantity: number;
    totalPrice: number;
    onCartChange?: () => void;
    selectedItems: ProductFull[];
}

export default function CartSummarySidebar({ totalQuantity, totalPrice, onCartChange, selectedItems }: CartSummarySidebarProps) {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [selectedVoucherIds, setSelectedVoucherIds] = useState<string[]>([]);
    const [messageApi, contextHolder] = message.useMessage();


    // State for cart calculations
    const [discountPrice, setDiscountPrice] = useState(0);
    const [finalPrice, setFinalPrice] = useState(0);

    // Vouchers from API
    const [apiVouchers, setApiVouchers] = useState<Vourcher[]>([]);

    useEffect(() => {
        const loadVouchers = async () => {
            const res = await fetchVourcherList();
            if (res && res.status && res.data) {
                setApiVouchers(res.data.items);
            }
        };
        loadVouchers();
    }, []);

    // Calculate discount
    useEffect(() => {
        const checkVoucher = async () => {
            if (selectedVoucherIds.length > 0 && selectedItems.length > 0) {
                const voucherId = selectedVoucherIds[0];
                const v = apiVouchers.find(item => item.id === voucherId);

                if (v) {
                    const user = JSON.parse(localStorage.getItem('user') || '{}');
                    const customer_id = user?.id || 0;

                    const listProduct = selectedItems.map(item => ({
                        id: item.id,
                        product_category_id: item.product_category_id,
                        price: item.rawPrice
                    }));

                    const res = await checkVourcherListProducts(v.code, totalPrice, listProduct, customer_id);
                    if (res && res.status) {
                        const totalAfterDiscount = res.data.total_after_discount;
                        setDiscountPrice(totalPrice - totalAfterDiscount);
                        messageApi.success("Áp dụng voucher thành công!");
                    } else {
                        if (res && res.error) {
                            messageApi.error(JSON.stringify(res.error));
                        }
                        setDiscountPrice(0);
                        setSelectedVoucherIds([]);
                    }
                }
            } else {
                setDiscountPrice(0);
            }
        };

        checkVoucher();
    }, [selectedVoucherIds, totalPrice, selectedItems, apiVouchers]);

    useEffect(() => {
        // Final price calculation
        const final = Math.max(0, totalPrice - discountPrice);
        setFinalPrice(final);
    }, [totalPrice, discountPrice]);

    const modalVouchers: Voucher[] = useMemo(() => {
        return apiVouchers.map(v => ({
            id: v.id,
            title: v.name || v.code,
            desc: v.describe || `Giảm ${v.value}${v.type === 1 ? '%' : 'đ'}`,
            code: v.code,
            exp_date: v.exp_date,
            disabled: totalPrice < v.min_amount
        }));
    }, [apiVouchers, totalPrice]);

    // Handle removing a voucher
    const removeVoucher = (id: string) => {
        setSelectedVoucherIds(prev => prev.filter(vid => vid !== id));
    };

    return (
        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-sm-12 MuiGrid-grid-md-3 ctrl-mobile-total">
            {contextHolder}
            <div className="styles_sidebarSticky__Kfyvt">
                <div className="styles_cartInfo__0SA1a">

                    <h3 className="styles_cartInfoHeading__XC2KU">Giỏ hàng</h3>

                    {/* Top numbers */}
                    <div className="styles_cartTop__8bSkd">
                        <div className="styles_cartItem__9XQUj">
                            <span className="styles_cartItemLabel__eFnz4">Số lượng</span>
                            <p className="styles_cartItemNumber__gEPCN">{totalQuantity}</p>
                        </div>

                        <div className="styles_cartItem__9XQUj">
                            <span className="styles_cartItemLabel__eFnz4">Tạm tính</span>
                            <p className="styles_cartItemNumber__gEPCN">{totalPrice.toLocaleString('vi-VN')}đ</p>
                        </div>
                    </div>

                    {/* Discount select bar */}
                    <div className="styles_cartBody__HwEuR">

                        <div role="button" className="styles_cartDiscountInput__FyhpR" onClick={() => setOpen(true)} >
                            <p className="styles_cartDiscountInputText__k7za6">
                                Chọn hoặc nhập mã giảm giá
                            </p>

                            <div className="styles_cartDiscountIcon__qAHa7">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M5.52729 3.52851C5.78764 3.26817 6.20975 3.26817 6.47011 3.52851L10.4701 7.52852C10.7304 7.78885 10.7304 8.21099 10.4701 8.47132L6.47011 12.4713C6.20975 12.7317 5.78764 12.7317 5.52729 12.4713C5.26694 12.211 5.26694 11.7889 5.52729 11.5285L9.0559 7.99992L5.52729 4.47133C5.26694 4.21097 5.26694 3.78887 5.52729 3.52851Z"
                                        fill="#E88438"
                                    />
                                </svg>
                            </div>
                        </div>

                        {/* discount total */}
                        <div className="styles_cartItem__9XQUj hidden-1199">
                            <span className="styles_cartItemLabel__eFnz4">Tổng giảm giá</span>
                            <p className="styles_cartItemNumber__gEPCN">{discountPrice.toLocaleString('vi-VN')}đ</p>
                        </div>

                        {/* applied voucher list */}
                        {selectedVoucherIds.map(id => {
                            const v = apiVouchers.find(item => item.id === id);
                            if (!v) return null;

                            return (
                                <div key={v.id} className="MuiGrid-root styles_cartDiscount__RJYT_ MuiGrid-item">
                                    <div className="styles_cartDiscountItem__8Ddi3">
                                        <div className="styles_cartDiscountInner__b2Oh0">
                                            <svg
                                                className="MuiSvgIcon-root styles_cartDiscountIcon__qAHa7 MuiSvgIcon-fontSizeSmall"
                                                viewBox="0 0 24 24"
                                                style={{ color: "rgb(47, 84, 235)" }}
                                            >
                                                <path d="M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58s1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41s-.23-1.06-.59-1.42zM13 20.01L4 11V4h7v-.01l9 9-7 7.02z" />
                                                <circle cx="6.5" cy="6.5" r="1.5" />
                                            </svg>

                                            <p
                                                className="MuiTypography-root styles_cartDiscountText__Lw6iE styles_noWrap__8pTB8 MuiTypography-body1"
                                                style={{ color: "rgb(47, 84, 235)", cursor: "pointer" }}
                                                title={v.code}
                                            >
                                                {v.code}
                                            </p>

                                            {/* delete voucher */}
                                            <button
                                                className="MuiButtonBase-root MuiIconButton-root"
                                                title="Xoá mã giảm giá"
                                                style={{ padding: 0, marginLeft: 10 }}
                                                type="button"
                                                onClick={() => removeVoucher(v.id)}
                                            >
                                                <span className="MuiIconButton-label">
                                                    <img
                                                        alt="icon del voucher"
                                                        src="https://cdn-web-next.thuocsi.vn/images/delete_voucher.svg"
                                                        style={{ width: '17px' }}
                                                    />
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* footer total */}
                    <div className="styles_cartFooter__i6d0j">

                        <div className="styles_cartItem__9XQUj">
                            <span className="styles_cartItemLabel__eFnz4 styles_bold__72Kns">
                                Tổng tiền
                            </span>

                            <p className="styles_cartItemNumber__gEPCN styles_primary__LIgRb">
                                {finalPrice.toLocaleString('vi-VN')}đ
                            </p>
                        </div>

                        <button onClick={() => {
                            
                            const selectedVouchers = apiVouchers.filter(v => selectedVoucherIds.includes(v.id));
                            if (selectedItems.length === 0) {
                                messageApi.error("Vui lòng chọn sản phẩm để mua hàng.");
                                return;
                            }
                            navigate("/checkout", { state: { selectedItems, selectedVouchers } });
                        }} className="styles_button__l7oVR styles_base__Pdm9S styles_contained__4kDf4 styles_colorPrimary__NGf0C styles_large__aTxqv">
                            Mua hàng
                        </button>
                    </div>

                </div>
            </div>
            <PromoVoucherModal
                open={open}
                onClose={() => setOpen(false)}
                vouchers={modalVouchers}
                defaultSelected={selectedVoucherIds}
                onSubmit={setSelectedVoucherIds}
                singleSelect={true}
            />
        </div>
    );
}
